export const EmployeeType = {
    ALL:0,
    EMPLOYEE: 1,
    PERMANENTEMPLOYEE: 2
}